export default __webpack_public_path__ + "static/media/asters_logo.a5e42f61.svg";